import { QuestionComponent } from 'app/models/questions/QuestionComponent'
import { EmailComponent } from 'app/modules/survey/survey-viewer/survey-question/types/email/email.component'
import { Props } from 'app/models/questions/Props'
import { LoremIpsum } from 'lorem-ipsum'
import {
  AbstractControl,
  UntypedFormControl,
  UntypedFormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators
} from '@angular/forms'
import { requireCommentOnOpenSelection } from 'app/form-validators/RequireCommentOnOpenSelectionValidator'

export class Email extends Props {

  private readonly _emailFormControlName = 'info_email'

  getDisplayComponent(): QuestionComponent {
    return new QuestionComponent(EmailComponent, this)
  }

  fillFormWithDummyAnswer(surveyForm) {
    this.setEverySelectedControlToTrueForGivenRow(surveyForm, this.rowKeys[this.rowKeys.length - 1])
    const validEmail = new LoremIpsum().generateWords(1) + '@ipsum.com'
    surveyForm.controls[this.key].get(this.rowKeys.pop()).get(this.commentsControlName).get(this.emailFormControlName).setValue(validEmail, {emitEvent: false})
  }

  buildQuestionFormGroup(): UntypedFormGroup {
    const formGroup = new UntypedFormGroup({})

    this.rowsOrder.forEach(rKey => {
      const validators = this.isOptional ? [] : [requireCommentOnOpenSelection(this.formControlName, this.commentsControlName, this.getOpenStatementsForRow(rKey))]
      let statementFormGroup = new UntypedFormGroup({
        [this.formControlName]: new UntypedFormGroup({
          [this.emailFormControlName]: new UntypedFormControl(true)
        }),
        [this.commentsControlName]: this.buildEmailCommentFormGroup()
      }, validators)
      formGroup.addControl(rKey, statementFormGroup)
    })

    return formGroup
  }

  private buildEmailCommentFormGroup(): UntypedFormGroup {
    const validators = this.addValidators()
    const form = new UntypedFormGroup({})
    form.addControl(this.emailFormControlName, new UntypedFormControl('', {validators}))
    return form
  }

  private addValidators(): ValidatorFn[] {
    let validators: ValidatorFn[] = [Validators.email]

    if (!this.isOptional) {
      validators.push(Validators.required)
    }

    return validators
  }

  get emailFormControlName() {
    return this._emailFormControlName
  }



}
